import MasterCard from "@/assets/paymentIcons/mastercard";
import RuPay from "@/assets/paymentIcons/rupay";
import VISA from "@/assets/paymentIcons/visa";
import { Input } from "@/components/ui/input";
import React from "react";
import PaymentButton from "./payment-button";


const CardPayment = () => {
    return (
        <div>
            <div className="flex items-center gap-3">
                <MasterCard />
                <VISA />
                <RuPay />
            </div>

            <div>
                <div className="flex items-center gap-5 my-6">
                    <div className="w-2/3">
                        <Input placeholder="Card Number" />
                    </div>
                    <div className="w-1/4">
                        <Input placeholder="MM/YY" />
                    </div>
                    <div className="w-40">
                        <Input placeholder="CVV" />
                    </div>
                </div>
                    <div>
                        <Input placeholder="Name on Card" />
                    </div>

                    <PaymentButton/>
            </div>
        </div>
    )
}

export default CardPayment;